<form [formGroup]="visibilityFormGroup">
  <div class="visibility-wrapper">
    <div class="outer-container">
      <div class="header">
        <h5>Calculation</h5>
      </div>
      <div class="upload-section">
      </div>
    </div>
    <div>
      <div class="d-flex align-items-center gap flex-wrap">
        <div class="ml-10 d-flex align-items-center">
          <app-admin-selection-dropdown
          [label]="'Select Layer'"
          [placeholder]="'Select a Layer'"
          [options]="layerOptionList"
          [showSearchBar]="false"
          (selectionChangecustom)="onLayerSelection($event)"
          formControlName="layerName"
          class="ml-1"
        >
        </app-admin-selection-dropdown>
          <!-- <label for=""
            >Select Property UID <span class="mandatory">*</span> :
          </label>
          <app-admin-selection-dropdown
          [label]="'Select Layer'"
          [placeholder]="'Select a Layer'"
          [options]="layerOptionList"
          [showSearchBar]="false"
          (selectionChangecustom)="onLayerSelection($event)"
          formControlName="layerName"
          class="ml-1"
        >
        </app-admin-selection-dropdown>
           Reusable dropdown component -->
          <app-admin-selection-dropdown
            [label]="'Select Property UID'"
            [placeholder]="'Select a Property UID'"
            [options]="propertyListOptions"
            [showSearchBar]="true"
            formControlName="propertyDetailsControl"
            class="ml-1"
          >
          </app-admin-selection-dropdown>
          <!-- Reusable input component  component  for showing name -->
          <!-- <app-admin-input-field
            label="Property Name"
            placeholder="Property Name"
            [required]="false"
            [commaSeparatedOnly]="false "
             [isReadOnly]="true"
             formControlName="propertyValueName"
            class="ml-1 custom-input-field"
          ></app-admin-input-field> -->
        </div>
        <button
          class="btn-submit"
          type="button"
          (click)="calculate()"
          [disabled]="visibilityFormGroup.invalid"
        >
          Calculate
        </button>
        <!-- <button class="btn-submit" type="button" (click)="downloadFile()" [disabled]="visibilityFormGroup.invalid">Download</button> -->
        <button
          mat-icon-button
          matTooltip="Refresh list"
          class="refresh"
          (click)="getCalcutionData()"
        >
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
<div class="bbar w-100" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" class="btm"></mat-progress-bar>
</div>

<app-admin-data-table
  [data]="selectedData"
  [columns]="selectedColumns"
  [buttons]="buttonConfig"
  [isIcon]="true"
  [totalCount]="totalCount"
  (pageChangeAction)="pageChangeAction($event)"
  [statusMap]="statusMap"
>
</app-admin-data-table>
